export default __webpack_public_path__ + "static/media/shopping_cart.7da131ac.svg";